"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.advanced-prompts.disabled': '高级提示功能在您当前的计划中不可用。',
};
